import type { TourStep } from '@/components/ui/Tour';
import { PLAY_EVENT_CREATE_TOUR_STEP_IDS } from '../tour-constants';
import { TourStepContent } from './StepContent';

/** New play event drawer — format, schedule, registration, and courts. */
export const playEventCreateTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Create a play event"
        description="Set up a draft social, round robin, or elimination event. Publish it from the event page when you are ready to open registration."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.DRAWER,
    position: 'left',
  },
  {
    content: (
      <TourStepContent
        title="Event basics"
        description="Name the event and choose format, side (singles or doubles), and any gender restriction."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.BASICS,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Date and duration"
        description="Pick when the event starts and how long it runs. Tournament formats can also set a participant withdraw deadline."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.SCHEDULE,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Who can join and pricing"
        description="Set join policy, payment collection, per-participant prices, and optional capacity. Leave prices blank for free entry."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.REGISTRATION,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Reserve courts"
        description="Select courts for the full event window. Conflicts with other bookings are blocked when you publish."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.COURTS,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Listing and kiosk options"
        description="Add a cover image, feature the event on your public page, enable match scoring, and optionally allow day-of kiosk registration."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.OPTIONS,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Create draft event"
        description="Save as a draft, then publish and set up the draw when you are ready for players to join."
      />
    ),
    selectorId: PLAY_EVENT_CREATE_TOUR_STEP_IDS.SUBMIT,
    position: 'top',
  },
];
